import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import api from '../../../../services/api';
import { useCliente } from '../../../../hooks/cliente';

const MatrizConsultaContext = createContext({});

function MatrizConsultaProvider({ children }) {
  const { updateNavegarMenu } = useCliente();
  const [loading, setLoading] = useState(false);
  const [matrizLista, setMatrizLista] = useState([]);
  const [clienteLista, setClienteLista] = useState([]);
  const [editMatriz, setEditMatriz] = useState(false);
  const [validarConsulta, setValidarConsulta] = useState(true);
  const [validarMatriz, setValidarMatriz] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [matriz, setMatriz] = useState({});
  const [matrizEditItem, setMatrizEditItem] = useState({});
  const [isEditMatriz, setIsEditMatriz] = useState(false);
  const [consultaLista, setConsultaLista] = useState([]);
  const [tipoConsultaLista, setTipoConsultaLista] = useState([]);
  const [messagem, setMessagem] = useState({
    type: '',
    msg: '',
    error: null,
  });

  const formatMatriz = array => array?.map(item => {
      const {
        reprovacaoAutomatica,
        idConsulta,
        idConsultaContigencia,
        idTipoCadastro,
        diasValidadeConsulta,
      } = item;
      return {
        reprovacaoAutomatica,
        idConsulta,
        idConsultaContigencia,
        idTipoCadastro,
        diasValidadeConsulta,
      };
    });

  const getMatrizLista = useCallback(async () => {
    try {
      const response = await api.get('/Matriz/list');

      if (response?.status === 200) {
        setMatrizLista(response?.data || []);
      }
    } catch (error) {
      setMatrizLista([]);
    }
  }, []);

  const getClienteLista = useCallback(async () => {
    const register = '1000';
    const page = '1';
    try {
      const response = await api.get(
        `/Cliente/clientesUsuario?page=${page}&numeroRegistros=${register}`
      );

      if (response?.status === 200) {
        setClienteLista(response?.data?.items || []);
      }
    } catch (error) {
      setClienteLista([]);
    }
  }, []);

  const getConsultaLista = useCallback(async () => {
    try {
      const response = await api.get('/Consulta/list?NumeroRegistros=100');
      if (response?.status === 200) {
        setConsultaLista(response?.data?.items || []);
      }
    } catch (error) {
      setConsultaLista([]);
    }
  }, []);

  const getTipoConsultaLista = useCallback(async () => {
    try {
      const response = await api.get('/TipoCadastro/list');
      if (response?.status === 200) {
        setTipoConsultaLista(response?.data || []);
      }
    } catch (error) {
      setTipoConsultaLista([]);
    }
  }, []);

  const updateValidarConsulta = useCallback(value => {
    setValidarConsulta(value);
  }, []);

  const updateValidarMatriz = useCallback(value => {
    setValidarMatriz(value);
  }, []);

  const updateMatriz = useCallback(item => {
    setMatriz(item);
  }, []);

  const updateEditMatriz = useCallback(value => {
    setEditMatriz(value);
    setIsEditMatriz(value);
  }, []);

  const updateOpenForm = useCallback(value => {
    setOpenForm(value);
  }, []);

  const updateMatrizItemEdit = useCallback(value => {
    setMatrizEditItem(value);
  }, []);

  const updateMenssage = useCallback(value => {
    setMessagem(value);
  }, []);

  const createNewMatriz = useCallback(
    async matriz => {
      const newConsultas = formatMatriz(matriz?.consultas || []);
      const newMatriz = {
        ...matriz,
        consultas: newConsultas,
      };
      try {
        setLoading(true);
        const response = await api.post('/Matriz', newMatriz);
        if (response?.status === 200) {
          setMessagem({
            type: 'sucess',
            msg: 'Matriz foi criada com sucesso.',
          });
          updateOpenForm(false);
          updateMatriz({});
          updateMatrizItemEdit({});
        }
        getMatrizLista();
        setLoading(false);
        return response;
      } catch (error) {
        setMessagem({
          type: 'error',
          msg: error?.response?.data?.detail || '',
          error,
        });
        setLoading(false);
        return error;
      }
    },
    [getMatrizLista, updateMatriz, updateMatrizItemEdit, updateOpenForm]
  );

  const updateMatrizCadastro = useCallback(
    async matriz => {
      try {
        setLoading(true);
        const response = await api.put('/Matriz', matriz);
        if (response?.status === 200) {
          setMessagem({
            type: 'sucess',
            msg: 'Matriz foi atualizada com sucesso.',
          });
          updateOpenForm(false);
        }
        getMatrizLista();
        updateMatriz({});
        updateMatrizItemEdit({});
        updateEditMatriz(false);
        setLoading(false);
        return response;
      } catch (error) {
        setMessagem({
          type: 'error',
          msg: error?.response?.data?.detail || '',
          error,
        });
        setLoading(false);
      }
    },
    [
      getMatrizLista,
      updateEditMatriz,
      updateMatriz,
      updateMatrizItemEdit,
      updateOpenForm,
    ]
  );

  const deleteMatriz = useCallback(
    async id => {
      try {
        setLoading(true);
        const response = await api.delete(`/Matriz/${id}`);
        if (response?.status === 200) {
          updateOpenForm(false);
          updateEditMatriz({});
          updateMatriz({});
          setMessagem({
            type: 'sucess',
            msg: 'Matriz foi excluída com sucesso.',
          });
        }
        getMatrizLista();
        setLoading(false);
        return response;
      } catch (error) {
        setMessagem({
          type: 'error',
          msg: error?.response?.data?.detail || '',
          error,
        });
        setLoading(false);
        return error;
      }
    },
    [getMatrizLista, updateOpenForm, updateEditMatriz, updateMatriz]
  );

  useEffect(() => {
    getMatrizLista();
  }, [getMatrizLista]);

  useEffect(() => {
    getClienteLista();
    getTipoConsultaLista();
    getConsultaLista();
  }, [getClienteLista, getTipoConsultaLista, getConsultaLista]);

  useEffect(() => {
    const value =
      Object.values(matriz).length > 0 ||
      Object.values(matrizEditItem).length > 0;
    updateNavegarMenu(!value);
  }, [matriz, matrizEditItem, updateNavegarMenu]);

  return (
    <MatrizConsultaContext.Provider
      value={{
        matriz,
        openForm,
        messagem,
        editMatriz,
        matrizLista,
        clienteLista,
        isEditMatriz,
        consultaLista,
        validarMatriz,
        matrizEditItem,
        validarConsulta,
        tipoConsultaLista,
        updateEditMatriz,
        updateValidarConsulta,
        updateValidarMatriz,
        updateMatriz,
        createNewMatriz,
        deleteMatriz,
        updateMatrizCadastro,
        updateOpenForm,
        updateMatrizItemEdit,
        updateMenssage,
      }}
    >
      <Spin spinning={loading} size="large" tipe="" delay={200}>
        {children}
      </Spin>
    </MatrizConsultaContext.Provider>
  );
}

const useMatrizConsulta = () => useContext(MatrizConsultaContext);

MatrizConsultaProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { useMatrizConsulta, MatrizConsultaProvider };
